import { render, staticRenderFns } from "./TemplateModules.vue?vue&type=template&id=86c7f8f8&scoped=true"
import script from "./TemplateModules.vue?vue&type=script&lang=js"
export * from "./TemplateModules.vue?vue&type=script&lang=js"
import style0 from "./TemplateModules.vue?vue&type=style&index=0&id=86c7f8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c7f8f8",
  null
  
)

export default component.exports